<template>
	<div id="app">

		<!-- <div v-if="!supported" class="warning">
			<h3>Sorry, this website doesn't support Internet Explorer anymore.</h3>
			<h3><a href="https://medium.com/@burger.neal/the-end-of-life-of-internet-explorer-11-12736f9ff75f">This</a> article does a good job at explaining why I no longer support Internet Explorer.</h3>
		</div> -->


		<navigation />

		<transition name="primary">
			<router-view/>
		</transition>

	</div>
</template>
<script>
import Navigation from '@/components/Navigation'

export default {
	name: 'home',
	data: function(){
		return {
			supported: true
		}
	},
	components: 
	{
		Navigation
	},
	watch: {

	},
	mounted() {

		
	}
}
</script>
<style>

.warning{
	position: absolute;
	left: 0px;
	right: 0px;
	padding: 10px;
	background-color: red;
}

footer{
	min-height: 120px;
	display: flex;
	text-transform: uppercase;
	font-size: 12px;
	justify-content: center;
	align-items: center;
	align-content: center;
	color: #b9b8b8;
}
.footer-item{
	display: flex;
	padding: 15px;
	align-items: center;
}
.footer-item a{
	color: #ABABAB;
    text-decoration: none;
    text-transform: uppercase;
    user-select: none;
	    transition: all 0.2s ease;
}

.footer-item a:hover{
    color: #e89a9d;
}


body{
	display: flex;

	margin: 0px;
	justify-content: center;
	font-size: 16px;
	font-weight: 500;

	padding: 0px 20px 0px 20px; 
}

#app {

	font-family: 'Open Sans', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;

	max-width: 960px;
}

::selection{
	background: #b9d7f1;
}

#nav {
	padding: 30px;	
}

#nav a {
	font-weight: bold;
	color: #2c3e50;
}

#nav a.router-link-exact-active {
	color: #42b983;
}


</style>
